import { render, staticRenderFns } from "./ProductionTable.vue?vue&type=template&id=d987bde4&scoped=true&"
import script from "./ProductionTable.vue?vue&type=script&lang=ts&"
export * from "./ProductionTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTable.vue?vue&type=style&index=0&id=d987bde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987bde4",
  null
  
)

export default component.exports